import {ISheetOrder} from '@/models/ISheetOrder';
import {apiClient} from '@/services/base/BaseService';
import {IOrder} from '@/models/IOrder';
import {VPaginationRequestData} from '@/utils/VPaginationRequestData';

export interface IFilterFulfillment {
    query: string;
}

export async function getSheetOrders(organizationId: number, shopId: number, filterData: VPaginationRequestData<IFilterFulfillment>): Promise<ISheetOrder[]> {
    const url = `organizations/${organizationId}/shops/${shopId}/sheet-orders`;
    const response = await apiClient.get(url, {
        params: {
            query: filterData.filterData.query,
        }
    });
    let orders = [];
    if (response.status === 200) {
        orders = response.data.data;
    }
    return orders;
}

export async function getOrdersOfSheetOrder(organizationId: number, shopId: number, sheetOrderId: number): Promise<IOrder[]> {
    const url = `organizations/${organizationId}/shops/${shopId}/sheet-orders/${sheetOrderId}/orders`;
    const response = await apiClient.get(url);
    let orders = [];
    if (response.status === 200) {
        orders = response.data.data;
    }
    return orders;
}

export async function publishSheetOrders(organizationId: number, shopId: number, sheetOrderId: number) {
    const url = `organizations/${organizationId}/shops/${shopId}/sheet-orders/${sheetOrderId}/publish`;
    const response = await apiClient.post(url);

    return response.status === 200;

}


